/**
 * © 2026 Desktronic. All rights reserved.
 * Proprietary code. Unauthorized copying, distribution or use
 * without written permission from Desktronic is prohibited.
 * Source: desktronic.lt | desktronicline.com | desktronic.se | desktronic.pl | desktronic.com/pl | desktronic.fr | desktronic.co.uk | desktronic.be | desktronic.nl | desktronic.dk | desktronic.com |  desktronic.cz
 */

// sig:dt-a7f3c91e04b2
$(document).ready(function () {
    // ─── Translation strings — sourced from Liquid data attributes ───────────────
    var $t = $("#reviews-translations-data");
    function td(key) {
      return ($t.length ? $t.attr("data-" + key) : "") || "";
    }
  
    var targetLang = (td("target-lang") || "FR").toUpperCase();
    var skipLanguage = td("skip-lang").toLowerCase();
  
    var translatedLang = (window.translatedLang = {
      translateBtn: td("translate-btn"),
      revertBtn: td("revert-btn"),
      loadingBtn: td("loading-btn"),
      wasThisHelpful: td("was-helpful"),
      noComments: td("no-comments"),
      upvoted: td("upvoted"),
      sortLabel: td("sort-label"),
      sortOptions: {
        "Newest First": td("sort-newest-first"),
        "Oldest First": td("sort-oldest-first"),
        "Most Popular": td("sort-most-popular"),
        "Most Helpful": td("sort-most-helpful"),
        "Highest Rating": td("sort-highest-rating"),
        "Highest Rated": td("sort-highest-rated"),
        "Lowest Rated": td("sort-lowest-rated"),
        "Order By": td("sort-order-by"),
        "Reviews With": td("sort-reviews-with"),
        Breakdown: td("sort-breakdown"),
        "Any Media": td("sort-any-media"),
        Images: td("sort-images"),
        Videos: td("sort-videos"),
        "Clear Filters": td("sort-clear-filters"),
        "Product Reviews": td("sort-product-reviews"),
      },
      justNow: td("time-just-now"),
      secondsAgo: td("time-seconds-ago"),
      oneMinuteAgo: td("time-one-minute-ago"),
      minutesAgo: td("time-minutes-ago"),
      oneHourAgo: td("time-one-hour-ago"),
      hoursAgo: td("time-hours-ago"),
      yesterday: td("time-yesterday"),
      daysAgo: td("time-days-ago"),
      oneWeekAgo: td("time-one-week-ago"),
      weeksAgo: td("time-weeks-ago"),
      oneMonthAgo: td("time-one-month-ago"),
      monthsAgo: td("time-months-ago"),
      oneYearAgo: td("time-one-year-ago"),
      yearsAgo: td("time-years-ago"),
      langCities: {
        lt: td("city-lt"),
        de: td("city-de"),
        fr: td("city-fr"),
        pl: td("city-pl"),
        sv: td("city-sv"),
        da: td("city-da"),
        nl: td("city-nl"),
        en: td("city-en"),
      },
      locationFallback: td("city-fallback"),
      skipLang: skipLanguage,
    });
  
    var DEEPL_PROXY_URL = "https://purple-pine-d02a.dev-53f.workers.dev/";
  
    // ─── Language detection ───────────────────────────────────────────────────────
    window.detectLangByChars = function (text) {
      if (!text) return null;
      var t = text.toLowerCase();
      if (/[ėįųū]/.test(t)) return "lt";
      if (/[ćłńśźż]/.test(t)) return "pl";
      if (/ß/.test(t)) return "de";
      if (/å/.test(t) && !/ø/.test(t)) return "sv";
      if (/ø/.test(t)) return "da";
      if (/[œæçéèêëàâîïôûù]/.test(t)) return "fr";
      if (/[äöü]/.test(t)) return "de";
      if (
        /\b(ich|bin|ist|das|die|der|ein|eine|einen|nicht|sehr|gut|mit|auch|noch|aber|mehr|beim|aus|zum|wurde|haben|hatte|tisch|schreibtisch|lieferung|produkt|super|leider|alles)\b/.test(t)
      )
        return "de";
      if (
        /\b(mooi|prijs|kwaliteit|stoel|bureaustoel|worden|heeft|zijn|niet|ook|goed|gebruik|absoluut|bureaustoel|ergonomisch)\b/.test(t)
      )
        return "nl";
      return "en";
    };
  
    // ─── Filter translate buttons for skip-language reviews ──────────────────────
    // Called by loadReviewData in reviews-pdp_script.js
    window.detectAndFilterTranslateBtns = function () {
      $(".review-translate-btns_outer").each(function () {
        var $btnOuter = $(this);
        var $item = $btnOuter.closest(".R-ContentList__item");
        if ($item.data("lang-checked")) return;
        var $bodyEl = $item.find(".item__review .R-TextBody.R-TextBody--xs").first();
        if ($bodyEl.find("em").length) $bodyEl.hide(); // hide no-comments placeholder immediately
        var bodyText = $bodyEl.find("em").length ? "" : $bodyEl.text().trim();
        $item.data("lang-checked", true);
  
        // Body empty → only keep if title has actual letters (not just "...")
        if (!bodyText) {
          var $titleDiv = $item.find(".item__inner .u-displayFlex.u-flexAlignItems--center.u-marginBottom--xs").children("div").last();
          var titleText = $titleDiv.text().trim();
          var hasMeaningfulTitle = /[a-zA-ZÀ-žĄ-ž]/.test(titleText);
          if (!hasMeaningfulTitle) {
            $btnOuter.remove();
            $item.attr("data-no-translate", "1");
            return;
          }
        }
      });
    };
  
    // ─── Helpers ──────────────────────────────────────────────────────────────────
    function textToHtml(text) {
      return $("<div>").text(text).html().replace(/\n/g, "<br>");
    }
  
    function injectLocation($item, lang) {
      var $authorDetails = $item.find(".c-meta__authorDetails");
      if (!$authorDetails.length) return;
      var $existing = $authorDetails.find(".c-meta__authorLocation");
      if ($existing.length && $existing.first().text().trim()) return;
      var city = (translatedLang.langCities || {})[lang] || translatedLang.locationFallback;
      if ($existing.length) {
        $existing.first().text(city).attr("data-injected-location", "1");
      } else {
        $authorDetails.append(
          '<div class="R-TextBody R-TextBody--xxxxs u-textLeft--all u-marginBottom--none c-meta__authorLocation" data-injected-location="1">' +
            city +
            "</div>",
        );
      }
    }
  
    function applyTranslation($item, $body, translatedBody, translatedTitle) {
      var $titleContainer = $item
        .find(".item__inner .u-displayFlex.u-flexAlignItems--center.u-marginBottom--xs")
        .first();
      var titleHtml = translatedTitle
        ? '<div class="review-translated-title">' + textToHtml(translatedTitle) + "</div>"
        : "";
      var bodyHtml = translatedBody
        ? '<div class="review-translated-body R-TextBody R-TextBody--xs u-textLeft--all">' +
          textToHtml(translatedBody) +
          "</div>"
        : "";
      $body.after('<div class="review-translation-block">' + titleHtml + bodyHtml + "</div>");
      $titleContainer.hide();
      $body.hide();
      $item.find(".review_translate-btn").hide();
      $item.find(".review_loading-btn").css({ opacity: 0, pointerEvents: "none" });
      $item.find(".review_revert-btn").show();
    }
  
    // ─── Batch translate all visible reviews (one request) ───────────────────────
    var _sectionInView = false;
    var _translateGen = 0;
  
    function translateAllReviews() {
      var myGen = ++_translateGen;
      $(".pdp_reviews-box").removeClass("loaded");
  
      var attempts = 0;
      var lastItemCount = -1;
      function tryTranslate() {
        if (myGen !== _translateGen) return; // stale call — a newer one is running
        // Wait until every review item either has a translate button or is marked
        // no-translate — ensures loadReviewData has processed the full list.
        var $items = $(".R-ContentList__item");
        var currentCount = $items.length;
        var btnCount = $(".review-translate-btns_outer").length;
        var noTransCount = $items.filter("[data-no-translate]").length;
        var allReady = currentCount > 0 && btnCount + noTransCount >= currentCount;
        // Also require item count to be stable vs. the previous check — the widget
        // renders items incrementally, so allReady can pass while more items are
        // still being added to the DOM.
        var countStable = (currentCount === lastItemCount);
        lastItemCount = currentCount;
        if ((!allReady || !countStable) && attempts++ < 20) {
          setTimeout(tryTranslate, 400);
          return;
        }
  
        var tasks = [];
        var allTexts = [];
  
        $(".R-ContentList__item").each(function () {
          var $item = $(this);
          if ($item.data("translated") || $item.attr("data-no-translate")) return;
          // Only process items loadReviewData has confirmed as translatable (has button).
          // Skipping items without buttons avoids falsely marking still-loading items
          // as no-translate when the widget hasn't finished populating their text yet.
          if (!$item.find(".review-translate-btns_outer").length) return;
  
          var $body = $item.find(".item__review .R-TextBody.R-TextBody--xs").first();
          // <em> no-comments placeholder is treated as empty — never translate it
          var bodyText = $body.find("em").length ? "" : $body.text().trim();
  
          var $titleInner = $item
            .find(".item__inner .u-displayFlex.u-flexAlignItems--center.u-marginBottom--xs")
            .children("div")
            .last();
          var titleText = $titleInner.text().trim();
  
          if (!bodyText && !titleText) return;
  
          var task = { $item: $item, $body: $body, bodyText: bodyText, titleText: titleText };
          if (bodyText) { task.bodyIdx = allTexts.length; allTexts.push(bodyText); }
          if (titleText) { task.titleIdx = allTexts.length; allTexts.push(titleText); }
          $item.data("translated", true);
          tasks.push(task);
        });
  
        if (!tasks.length) {
          $(".pdp_reviews-box").addClass("loaded");
          return;
        }
  
        tasks.forEach(function (task) {
          task.$item.find(".review_translate-btn").hide();
          task.$item.find(".review_loading-btn").css({ opacity: 1, pointerEvents: "none" });
        });
  
        $.ajax({
          url: DEEPL_PROXY_URL,
          method: "POST",
          contentType: "application/json",
          data: JSON.stringify({ texts: allTexts, target_lang: targetLang }),
          success: function (res) {
            if (myGen !== _translateGen) return; // stale response — discard
            var results = res.translatedTexts || [];
            var detectedLangs = res.detectedSourceLanguages || [];
            tasks.forEach(function (task) {
              // Use DeepL's detected source language to discard reviews already in
              // the skip language (e.g. English reviews sent because char-detection
              // can't reliably identify all languages like Dutch).
              var refIdx = task.bodyIdx != null ? task.bodyIdx : task.titleIdx;
              var detectedLang = (refIdx != null && detectedLangs[refIdx])
                ? detectedLangs[refIdx].toLowerCase()
                : "";
  
              if (detectedLang && detectedLang === skipLanguage) {
                task.$item.find(".review-translate-btns_outer").remove();
                task.$item.removeData("translated");
                // "confirmed" prevents the loadReviewData un-marking loop from
                // re-adding the button on the next 1-second tick.
                task.$item.attr("data-no-translate", "confirmed");
                return;
              }
  
              var translatedBody = task.bodyIdx != null ? results[task.bodyIdx] || task.bodyText : "";
              var translatedTitle = task.titleIdx != null ? results[task.titleIdx] || task.titleText : "";
  
              // Fallback (no detectedSourceLanguages from proxy yet): if translated
              // text is identical to the original, DeepL already saw it as the target
              // language — discard silently.
              if (!detectedLang && translatedBody === task.bodyText && translatedTitle === task.titleText) {
                task.$item.find(".review-translate-btns_outer").remove();
                task.$item.removeData("translated");
                task.$item.attr("data-no-translate", "confirmed");
                return;
              }
  
              injectLocation(task.$item, detectedLang || window.detectLangByChars(translatedBody || translatedTitle));
              applyTranslation(task.$item, task.$body, translatedBody, translatedTitle);
            });
  
            $(".pdp_reviews-box").addClass("loaded");
          },
          error: function () {
            if (myGen !== _translateGen) return; // stale response — discard
            tasks.forEach(function (task) {
              task.$item.removeData("translated");
              task.$item.find(".review_translate-btn").show();
              task.$item.find(".review_loading-btn").css({ opacity: 0, pointerEvents: "none" });
            });
  
            $(".pdp_reviews-box").addClass("loaded");
          },
        });
      }
  
      setTimeout(tryTranslate, 300);
    }
  
    // ─── Translate / revert click handlers ───────────────────────────────────────
    $(document).on("click", ".review_translate-btn", function () {
      var $item = $(this).closest(".R-ContentList__item");
      var $body = $item.find(".item__review .R-TextBody.R-TextBody--xs").first();
      var $titleContainer = $item
        .find(".item__inner .u-displayFlex.u-flexAlignItems--center.u-marginBottom--xs")
        .first();
      if (!$item.find(".review-translation-block").length || !$body.length) return;
      $item.find(".review-translation-block").show();
      $titleContainer.hide();
      $body.hide();
      $item.find(".review_translate-btn").hide();
      $item.find(".review_revert-btn").show();
    });
  
    $(document).on("click", ".review_revert-btn", function () {
      var $item = $(this).closest(".R-ContentList__item");
      var $body = $item.find(".item__review .R-TextBody.R-TextBody--xs").first();
      var $titleContainer = $item
        .find(".item__inner .u-displayFlex.u-flexAlignItems--center.u-marginBottom--xs")
        .first();
      $item.find(".review-translation-block").hide();
      $titleContainer.show();
      if (!$body.find("em").length) $body.show();
      $item.find(".review_translate-btn").show();
      $item.find(".review_revert-btn").hide();
      $item.find(".review_loading-btn").css({ opacity: 0, pointerEvents: "none" });
    });
  
    // ─── Static UI text replacements ─────────────────────────────────────────────
    var toastTextMap = {
      "You've upvoted this review as helpful.": translatedLang.upvoted,
    };
  
    function translateDropdownText($el, en, lt) {
      if ($el.children().length === 0) {
        if ($el.text().trim() === en) $el.text(lt);
      } else {
        $el.find("> .R-flex-row > div:first-child").each(function () {
          if ($(this).children().length === 0 && $(this).text().trim() === en) {
            $(this).text(lt);
          }
        });
      }
    }
  
    window.applyStaticTranslations = function () {
      $(".R-ContentList__item").each(function () {
        var $item = $(this);
        var bodyText = $item.find(".item__review .R-TextBody.R-TextBody--xs").first().text().trim();
        if (bodyText) injectLocation($item, window.detectLangByChars(bodyText));
      });
  
      window.detectAndFilterTranslateBtns();
  
      $(".R-TextHeading--xxxxs.u-marginBottom--none.u-marginRight--sm").each(function () {
        if ($(this).text().trim() === "Was this review helpful?") {
          $(this).text(translatedLang.wasThisHelpful);
        }
      });
  
      $(".c-filters__triggerButton")
        .contents()
        .filter(function () {
          return this.nodeType === 3 && this.nodeValue.trim() === "Sort";
        })
        .each(function () {
          this.nodeValue = translatedLang.sortLabel + " ";
        });
  
      $.each(translatedLang.sortOptions, function (en, lt) {
        $(".R-DropUpDownMenu__item .R-TextBody, .R-DropUpDownMenu__item .R-TextHeading").each(function () {
          translateDropdownText($(this), en, lt);
        });
        $(".active-sort-label").each(function () {
          if ($(this).text().trim() === en) $(this).text(lt);
        });
        $(".R-TabControls__item .R-TextHeading").each(function () {
          if ($(this).text().trim() === en) $(this).text(lt);
        });
      });
  
      $(".filter__rsp-tab-sort-line p").each(function () {
        var $el = $(this);
        var lt = translatedLang.sortOptions[$el.text().trim()];
        if (lt) $el.text(lt);
      });
  
      $(".R-TextBody--xs em").each(function () {
        if ($(this).text().trim() === "Reviewer didn't leave any comments") {
          $(this).text(translatedLang.noComments);
        }
      });
  
      $(".R-LabelTag__text").each(function () {
        var $el = $(this);
        var lt = toastTextMap[$el.text().trim()];
        if (lt) $el.text(lt);
      });
  
      $(".c-reviewDateTime .R-TextBody--xxxs > div").each(function () {
        var $el = $(this);
        var lt = window.translateTimeToLt($el.text().trim());
        if (lt) $el.text(lt);
      });
    };
  
    window.translateTimeToLt = function (text) {
      var map = [
        [/^just now$/i, translatedLang.justNow],
        [/^(\d+)\s+second[s]? ago$/i, translatedLang.secondsAgo],
        [/^a minute ago$/i, translatedLang.oneMinuteAgo],
        [/^(\d+)\s+minute[s]? ago$/i, translatedLang.minutesAgo],
        [/^an? hour ago$/i, translatedLang.oneHourAgo],
        [/^(\d+)\s+hour[s]? ago$/i, translatedLang.hoursAgo],
        [/^yesterday$/i, translatedLang.yesterday],
        [/^(\d+)\s+day[s]? ago$/i, translatedLang.daysAgo],
        [/^a week ago$/i, translatedLang.oneWeekAgo],
        [/^(\d+)\s+week[s]? ago$/i, translatedLang.weeksAgo],
        [/^a month ago$/i, translatedLang.oneMonthAgo],
        [/^(\d+)\s+month[s]? ago$/i, translatedLang.monthsAgo],
        [/^a year ago$/i, translatedLang.oneYearAgo],
        [/^(\d+)\s+year[s]? ago$/i, translatedLang.yearsAgo],
      ];
      for (var i = 0; i < map.length; i++) {
        if (map[i][0].test(text)) return text.replace(map[i][0], map[i][1]);
      }
      return null;
    };
  
    // ─── Toast observer ───────────────────────────────────────────────────────────
    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          var $node = $(node);
          var targets = $node.is('[class*="Notification"], [class*="Toast"], [class*="Snack"]')
            ? $node
            : $node.find('[class*="Notification"], [class*="Toast"], [class*="Snack"]');
          targets.addBack().each(function () {
            var $el = $(this);
            $.each(toastTextMap, function (en, lt) {
              if ($el.text().trim() === en) $el.text(lt);
            });
          });
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  
    // ─── Popup translate / revert ─────────────────────────────────────────────────
    function setPopupBtnState($popup, state) {
      var $translateBtn = $popup.find(".rsp_popup-translate-btn");
      var $revertBtn = $popup.find(".rsp_popup-revert-btn");
      var $loadingBtn = $popup.find(".rsp_popup-loading-btn");
      if (state === "loading") {
        $translateBtn.hide();
        $loadingBtn.css({ opacity: 1, pointerEvents: "none" });
        $revertBtn.hide();
      } else if (state === "translated") {
        $translateBtn.hide();
        $loadingBtn.css({ opacity: 0, pointerEvents: "none" });
        $revertBtn.show();
      } else {
        $translateBtn.show();
        $loadingBtn.css({ opacity: 0, pointerEvents: "none" });
        $revertBtn.hide();
      }
    }
  
    window.initPopupTranslateButtons = function () {
      var $popup = $(".rsp_popup-outer");
      // Clean up previous popup's state
      $popup.find(".rsp_popup-translation-block").remove();
      $popup.find(".rsp-popup_review_content p").show();
      $popup.find(".rsp_popup-translate_btns").show();
      setPopupBtnState($popup, "original");
  
      var $body = $popup.find(".rsp-popup_review_content p");
      var originalBody = $body.text().trim();
      if (!originalBody) return;
  
      // Auto-translate on open — let DeepL detect the language
      setPopupBtnState($popup, "loading");
      $.ajax({
        url: DEEPL_PROXY_URL,
        method: "POST",
        contentType: "application/json",
        data: JSON.stringify({ texts: [originalBody], target_lang: targetLang }),
        success: function (res) {
          var detectedLang = ((res.detectedSourceLanguages || [])[0] || "").toLowerCase();
          var translated = (res.translatedTexts || [])[0] || originalBody;
  
          // If DeepL detected skip language (or fallback: text unchanged), hide buttons
          var isSkip = (detectedLang && detectedLang === skipLanguage) ||
                       (!detectedLang && translated === originalBody);
          if (isSkip) {
            $popup.find(".rsp_popup-translate_btns").hide();
            setPopupBtnState($popup, "original");
            setTimeout(function () { $(".rsp_popup-review-info").addClass("loaded"); }, 1000);
            return;
          }
  
          $body.after(
            '<div class="rsp_popup-translation-block R-TextBody R-TextBody--xxs">' +
              textToHtml(translated) +
              "</div>",
          );
          $body.hide();
          setPopupBtnState($popup, "translated");
          setTimeout(function () { $(".rsp_popup-review-info").addClass("loaded"); }, 1000);
        },
        error: function () {
          // On error show the original with the translate button available
          setPopupBtnState($popup, "original");
          setTimeout(function () { $(".rsp_popup-review-info").addClass("loaded"); }, 1000);
        },
      });
    };
  
    // Translate button: only visible after user reverts — re-shows existing translation
    $(document).on("click", ".rsp_popup-translate-btn", function () {
      var $popup = $(this).closest(".rsp_popup-outer");
      var $body = $popup.find(".rsp-popup_review_content p");
      if (!$popup.find(".rsp_popup-translation-block").length) return;
      $popup.find(".rsp_popup-translation-block").show();
      $body.hide();
      setPopupBtnState($popup, "translated");
    });
  
    $(document).on("click", ".rsp_popup-revert-btn", function () {
      var $popup = $(this).closest(".rsp_popup-outer");
      if (!$popup.find(".rsp_popup-translation-block").length) return;
      $popup.find(".rsp_popup-translation-block").hide();
      $popup.find(".rsp-popup_review_content p").show();
      setPopupBtnState($popup, "original");
    });
  
    // ─── Reset on pagination / sort / filter ─────────────────────────────────────
    // Reverse map: translated sort label → English, so the poller doesn't treat
    // label translation by applyStaticTranslations as a real sort change.
    var _sortLabelToEn = {};
    $.each(translatedLang.sortOptions, function (en, lt) {
      if (lt) _sortLabelToEn[lt] = en;
    });
  
    window.resetTranslations = function () {
      _translateGen++; // invalidate any in-flight batch request
      $(".R-ContentList__item").each(function () {
        $(this).find(".item__review .R-TextBody.R-TextBody--xs").first().show();
        $(this)
          .find(".item__inner .u-displayFlex.u-flexAlignItems--center.u-marginBottom--xs")
          .first()
          .show();
      });
      $(".review-translation-block").remove();
      $(".review-translate-btns_outer").remove();
      $("[data-injected-location]").remove();
      $(".R-ContentList__item").removeData("lang-checked translated").removeAttr("data-no-translate");
      if (_sectionInView) translateAllReviews();
    };
  
    // ─── Trigger when section enters viewport ────────────────────────────────────
    var $reviewsSection = $(".reviews-pdp");
  
    function checkReviewsInView() {
      if (!$reviewsSection.length || _sectionInView) return;
      var rect = $reviewsSection[0].getBoundingClientRect();
      if (rect.top < window.innerHeight && rect.bottom > 0) {
        _sectionInView = true;
        $(window).off("scroll.reviewsTranslate");
        translateAllReviews();
      }
    }
  
    if ($reviewsSection.length) {
      $(window).on("scroll.reviewsTranslate", checkReviewsInView);
      checkReviewsInView();
    }
  
    // ─── Pagination / sort / filter polling ──────────────────────────────────────
    // We debounce the actual reset by 600 ms so that rapid intermediate DOM states
    // (e.g. widget briefly clears activePage before rendering the new page number)
    // don't cause two separate skeleton cycles. On the *first* change we still
    // show the skeleton immediately so there's no visible delay for the user.
    var _lastReviewsState = null;
    var _resetTimer = null;
  
    function getReviewsState() {
      var activePage = $(".R-PaginationControls__item.isActive").attr("aria-label") || "";
      var rawLabel = $(".active-sort-label").first().text().trim() || "";
      var sortLabel = _sortLabelToEn[rawLabel] || rawLabel;
      var activeFilters = [];
      $(".R-DropUpDownMenu__item.isActive").each(function () {
        var idx = $(this).attr("data-order-index");
        activeFilters.push(idx !== undefined ? idx : $(this).index());
      });
      return activePage + "|" + sortLabel + "|" + activeFilters.join(",");
    }
  
    setInterval(function () {
      var state = getReviewsState();
      if (state !== _lastReviewsState) {
        var wasInit = _lastReviewsState !== null;
        _lastReviewsState = state;
        if (wasInit) {
          // Immediately invalidate any in-flight request and show skeleton,
          // but wait for the widget to fully settle before cleaning up the DOM.
          _translateGen++;
          $(".pdp_reviews-box").removeClass("loaded");
          clearTimeout(_resetTimer);
          _resetTimer = setTimeout(function () {
            // Re-snapshot state at fire time so any intermediate changes (e.g.
            // activePage going "" → "Page 2") are absorbed and don't trigger
            // a second reset cycle after translation completes.
            _lastReviewsState = getReviewsState();
            window.resetTranslations();
          }, 600);
        }
      }
    }, 300);
  });
  